import { render, staticRenderFns } from "./regis_union.vue?vue&type=template&id=18710796&scoped=true"
import script from "./regis_union.vue?vue&type=script&lang=js"
export * from "./regis_union.vue?vue&type=script&lang=js"
import style0 from "./regis_union.vue?vue&type=style&index=0&id=18710796&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18710796",
  null
  
)

export default component.exports